export default __webpack_public_path__ + "static/media/oph logo.8bc55a44.png";